<template>
  <div class="content container-fluid">
    <!-- Popover for Filter -->
    <popover
      name="popType"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranType"
        :options="colFilter.tran_type_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popMerchant"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranMerchant"
        :options="colFilter.tran_merchant_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popName"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranName"
        :options="colFilter.tran_name_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popIp"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranIp"
        :options="colFilter.tran_ip_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popKey"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranKey"
        :options="colFilter.tran_key_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popCode"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranCode"
        :options="colFilter.tran_code_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- /Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Audit Log</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Filter -->
    <div class="row">
      <div class="col-md-4 fit-content">
        <div class="form-group">
          <label>Type</label>
          <select class="form-control" v-model="type">
            <option :value="typeAdminUser">{{ typeAdminUser }}</option>
            <option :value="typeMerchantUser">{{ typeMerchantUser }}</option>
            <option :value="typeEcouponCodeAPI">
              {{ typeEcouponCodeAPI }}
            </option>
            <option :value="typeEcouponApiKeyReset">
              {{ typeEcouponApiKeyReset }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Date from</label>
          <input type="date" class="form-control" v-model="dateFrom" />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Date to</label>
          <input type="date" class="form-control" v-model="dateTo" />
        </div>
      </div>
      <div class="col-md-3" v-if="type != typeAdminUser">
        <div class="form-group">
          <label>Merchant</label>
          <Select2 v-model="merchantId" :options="merchants" />
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">
          Search
        </button>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-right" v-if="records && records.length">
        <button type="button" @click="exportCsv" class="btn btn-sm btn-primary">
          <img
            width="20px"
            height="20px"
            class="mr-1"
            src="../../assets/excel.png"
          />Export
        </button>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table
            class="table table-bordered custom-table mb-0"
            v-if="
              typeFilter == typeAdminUser ||
              typeFilter == typeMerchantUser ||
              typeFilter == typeEcouponApiKeyReset
            "
          >
            <thead class="thead-light">
              <tr>
                <th class="no-col">No</th>
                <th>
                  <button class="btn p-0" @click="setSortBy('date')">
                    Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'date'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'date_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th
                  v-if="
                    typeFilter == typeMerchantUser ||
                    typeFilter == typeEcouponApiKeyReset
                  "
                >
                  <i
                    class="fa fa-filter"
                    v-popover:popMerchant
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranMerchant.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('merchant')">
                    Merchant
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'merchant'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'merchant_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popName
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranName.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('name')">
                    User
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popIp
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranIp.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('ip')">
                    IP Address
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'ip'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'ip_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>Activity</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rec, i) in records" :key="rec.id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td>{{ rec.date_display }}</td>
                <td
                  v-if="
                    typeFilter == typeMerchantUser ||
                    typeFilter == typeEcouponApiKeyReset
                  "
                >
                  {{ rec.merchant }}
                </td>
                <td>{{ rec.name }}</td>
                <td>{{ rec.ip }}</td>
                <td v-html="rec.activity"></td>
              </tr>
              <tr v-if="records && !records.length">
                <td colspan="6" class="text-center">{{ noRecordText }}</td>
              </tr>
            </tbody>
          </table>

          <table
            class="table table-bordered custom-table mb-0"
            v-if="typeFilter == typeEcouponCodeAPI"
          >
            <thead class="thead-light">
              <th class="no-col">No</th>
              <th>
                <button class="btn p-0" @click="setSortBy('date')">
                  Date
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-1"
                      :style="[
                        paging.SortBy === 'date'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'date_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
              <th>
                <i
                  class="fa fa-filter"
                  v-popover:popMerchant
                  v-if="colFilter"
                  :style="[
                    searchColFilter.tranMerchant.length > 0
                      ? { color: 'orange' }
                      : { color: 'white' },
                  ]"
                ></i>
                <button class="btn p-0" @click="setSortBy('merchant')">
                  Merchant
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-1"
                      :style="[
                        paging.SortBy === 'merchant'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'merchant_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
              <th>
                <i
                  class="fa fa-filter"
                  v-popover:popType
                  v-if="colFilter"
                  :style="[
                    searchColFilter.tranType.length > 0
                      ? { color: 'orange' }
                      : { color: 'white' },
                  ]"
                ></i>
                <button class="btn p-0" @click="setSortBy('type')">
                  Type
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-1"
                      :style="[
                        paging.SortBy === 'type'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'type_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
              <th>
                <i
                  class="fa fa-filter"
                  v-popover:popIp
                  v-if="colFilter"
                  :style="[
                    searchColFilter.tranIp.length > 0
                      ? { color: 'orange' }
                      : { color: 'white' },
                  ]"
                ></i>
                <button class="btn p-0" @click="setSortBy('ip')">
                  Caller IP Address
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-1"
                      :style="[
                        paging.SortBy === 'ip'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'ip_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
              <th>
                <i
                  class="fa fa-filter"
                  v-popover:popKey
                  v-if="colFilter"
                  :style="[
                    searchColFilter.tranKey.length > 0
                      ? { color: 'orange' }
                      : { color: 'white' },
                  ]"
                ></i>
                <button class="btn p-0" @click="setSortBy('key')">
                  API Key
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-1"
                      :style="[
                        paging.SortBy === 'key'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'key_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
              <th>
                <i
                  class="fa fa-filter"
                  v-popover:popCode
                  v-if="colFilter"
                  :style="[
                    searchColFilter.tranCode.length > 0
                      ? { color: 'orange' }
                      : { color: 'white' },
                  ]"
                ></i>
                <button class="btn p-0" @click="setSortBy('code')">
                  Return Code
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-1"
                      :style="[
                        paging.SortBy === 'code'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'code_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
              <th>Remarks</th>
            </thead>
            <tbody>
              <tr v-for="(rec, i) in records" :key="rec.id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td>{{ rec.date_display }}</td>
                <td>{{ rec.merchant }}</td>
                <td>{{ rec.type }}</td>
                <td>{{ rec.ip }}</td>
                <td>{{ rec.api_key }}</td>
                <td>{{ rec.code }}</td>
                <td>{{ rec.remarks }}</td>
              </tr>
              <tr v-if="records && !records.length">
                <td colspan="8" class="text-center">{{ noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="records && records.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>
      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      typeAdminUser: config.AUDITLOG_TYPE_ADMIN_USER,
      typeMerchantUser: config.AUDITLOG_TYPE_MERCHANT_USER,
      typeEcouponCodeAPI: config.AUDITLOG_TYPE_ECOUPON_CODE_API,
      typeEcouponApiKeyReset: config.AUDITLOG_TYPE_API_KEY_RESET,
      records: [],
      //filter
      type: config.AUDITLOG_TYPE_ADMIN_USER,
      dateFrom: "",
      dateTo: "",
      merchantId: "0",
      merchants: [],
      //filter after search pressed
      typeFilter: config.AUDITLOG_TYPE_ADMIN_USER,
      dateFromFilter: "",
      dateToFilter: "",
      merchantIdFilter: "",
      //pagination
      searchColFilter: {
        tranType: [],
        tranMerchant: [],
        tranName: [],
        tranIp: [],
        tranKey: [],
        tranCode: [],
      },
      colFilter: {},
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
    searchFilter() {
      return [
        { name: "tranType", val: this.searchColFilter.tranType },
        { name: "tranMerchant", val: this.searchColFilter.tranMerchant },
        { name: "tranName", val: this.searchColFilter.tranName },
        { name: "tranIp", val: this.searchColFilter.tranIp },
        { name: "tranKey", val: this.searchColFilter.tranKey },
        { name: "tranCode", val: this.searchColFilter.tranCode },
      ];
    },
  },
  watch: {
    "searchColFilter.tranType": function (val, oldVal) {
      this.getAuditLogs();
    },
    "searchColFilter.tranMerchant": function (val, oldVal) {
      this.getAuditLogs();
    },
    "searchColFilter.tranName": function (val, oldVal) {
      this.getAuditLogs();
    },
    "searchColFilter.tranIp": function (val, oldVal) {
      this.getAuditLogs();
    },
    "searchColFilter.tranKey": function (val, oldVal) {
      this.getAuditLogs();
    },
    "searchColFilter.tranCode": function (val, oldVal) {
      this.getAuditLogs();
    },
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getAuditLogs();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    getMerchants() {
      API.getAllMerchants({}, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            response.data.records.unshift({ id: "0", text: "All" });
            this.merchants = response.data.records;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    search() {
      this.searchColFilter = {
        tranType: [],
        tranMerchant: [],
        tranName: [],
        tranIp: [],
        tranKey: [],
        tranCode: [],
      };
      this.colFilter = {};
      this.paging = {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      };
      this.totalRecords = "";
      this.typeFilter = this.type;
      this.dateFromFilter = this.dateFrom;
      this.dateToFilter = this.dateTo;
      this.merchantIdFilter =
        this.type != this.typeAdminUser ? this.merchantId : "";
      this.getAuditLogs();
    },
    exportCsv() {
      let param = {
        type: this.typeFilter,
        date_from: this.dateFromFilter,
        date_to: this.dateToFilter,
        merchant_id: this.merchantIdFilter == "0" ? "" : this.merchantIdFilter,
      };
      API.exportAuditLog(param, this.tokenObj.token)
        .then((response) => {
          const blob = new Blob([response.data], { type: "text/csv" });
          const link = document.createElement("a");
          const url = URL.createObjectURL(blob);
          link.href = url;
          let type = this.typeFilter.replaceAll(" ", "_");
          link.setAttribute("download", `AuditLog_${type}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAuditLogs() {
      let param = {
        type: this.typeFilter,
        date_from: this.dateFromFilter,
        date_to: this.dateToFilter,
        merchant_id: this.merchantIdFilter == "0" ? "" : this.merchantIdFilter,
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
        sort_by: this.paging.SortBy,
        search_filter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getAuditLogs(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.records;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.page_count;
            this.colFilter = response.data.col_filter;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getAuditLogs();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getAuditLogs();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getAuditLogs();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getAuditLogs();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getAuditLogs();
    },
    setSortBy(payload) {
      switch (payload) {
        case "date":
          if (this.paging.SortBy === "date") {
            this.paging.SortBy = "date_desc";
          } else if (this.paging.SortBy === "date_desc") {
            this.paging.SortBy = "date";
          } else {
            this.paging.SortBy = "date";
          }
          break;
        case "type":
          if (this.paging.SortBy === "type") {
            this.paging.SortBy = "type_desc";
          } else if (this.paging.SortBy === "type_desc") {
            this.paging.SortBy = "type";
          } else {
            this.paging.SortBy = "type";
          }
          break;
        case "merchant":
          if (this.paging.SortBy === "merchant") {
            this.paging.SortBy = "merchant_desc";
          } else if (this.paging.SortBy === "merchant_desc") {
            this.paging.SortBy = "merchant";
          } else {
            this.paging.SortBy = "merchant";
          }
          break;
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "ip":
          if (this.paging.SortBy === "ip") {
            this.paging.SortBy = "ip_desc";
          } else if (this.paging.SortBy === "ip_desc") {
            this.paging.SortBy = "ip";
          } else {
            this.paging.SortBy = "ip";
          }
          break;
        case "key":
          if (this.paging.SortBy === "key") {
            this.paging.SortBy = "key_desc";
          } else if (this.paging.SortBy === "key_desc") {
            this.paging.SortBy = "key";
          } else {
            this.paging.SortBy = "key";
          }
          break;
        case "code":
          if (this.paging.SortBy === "code") {
            this.paging.SortBy = "code_desc";
          } else if (this.paging.SortBy === "code_desc") {
            this.paging.SortBy = "code";
          } else {
            this.paging.SortBy = "code";
          }
          break;
      }
      this.getAuditLogs();
    },
  },
  created() {
    this.getAuditLogs();
    this.getMerchants();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/AuditLog.vue